import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';

const version = StFeatureFlagFlags.AuthServiceVersionProd.getValue();

const gateway = StFeatureFlagFlags.gatewayProd.getValue();

class AuthService extends Service {
  constructor(api) {
    super(api, {});
  }

  login(username, password) {
    const params = { username, password };
    return this.api.post({ ...params, url: 'login' });
  }

  logout(SSID) {
    const params = { 'Stilingue-Session-Id': SSID };
    return this.api.post({ ...params, url: 'logout' });
  }
}

const api = createApi(`auth/${version}/session/`, gateway, {
  authNotFound: () => true,
  error401Handler: (error) => {
    return Promise.reject(error);
  },
});
export default new AuthService(api);
